export default "__VITE_ASSET__a13ec61e__"